import { fg } from '@atlassian/jira-feature-gating';

const NinMultiGroupPickerCellRelayProvider = {
	get(): boolean {
		return fg('nin_multi_group_picker_cell');
	},
};

export default NinMultiGroupPickerCellRelayProvider;
